module.exports = __webpack_public_path__ + "img/ssl-banner.6a224faf.png";